/**
 * @fileoverview Component Showcase
 *
 * Purpose: Reusable component for displaying UI component examples
 * Used by: Component library sections
 */

interface ComponentShowcaseProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function ComponentShowcase({
  title,
  description,
  children,
}: ComponentShowcaseProps) {
  return (
    <section className="space-y-6">
      <div className="space-y-2">
        <h3 className="text-xl font-semibold tracking-tight">{title}</h3>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      <div className="rounded-lg border bg-card p-8">{children}</div>
    </section>
  );
}
